import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppModalType } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { QRAppSection } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/QRAppSection";
import { TextAppSection } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/TextAppSection";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Modal } from "@faire/web--source/slate/deprecated/Modal";
import { Tabs } from "@faire/web--source/slate/deprecated/Tabs";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerMobileFooterDesktopappModalandroidScanQrCodeTabClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalAndroidScanQrCodeTab";
import { trackRetailerMobileFooterDesktopappModalandroidTextMeTabClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalAndroidTextMeTab";
import { trackRetailerMobileFooterDesktopappModaliosScanQrCodeTabClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalIosScanQrCodeTab";
import { trackRetailerMobileFooterDesktopappModaliosTextMeTabClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalIosTextMeTab";
import React from "react";
var DownloadMethodsEnum;
(function(DownloadMethodsEnum) {
    DownloadMethodsEnum["QR"] = "QR";
    DownloadMethodsEnum["TEXT"] = "TEXT";
})(DownloadMethodsEnum || (DownloadMethodsEnum = {}));
var useTabs = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    return [
        {
            value: DownloadMethodsEnum.QR,
            label: strictLocalize({
                id: "ffxQWT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Scan QR Code"
                    }
                ]
            })
        },
        {
            value: DownloadMethodsEnum.TEXT,
            label: strictLocalize({
                id: "Y/dNDc",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Text me"
                    }
                ]
            })
        }
    ];
};
export var LoggedOutAppDownloadModal = function(props) {
    var tabs = useTabs();
    var _React_useState = _sliced_to_array(React.useState(DownloadMethodsEnum.QR), 2), activeDownloadMethodTab = _React_useState[0], setDownloadMethodActiveTab = _React_useState[1];
    var trackAndSetNewTab = function(newTab) {
        setDownloadMethodActiveTab(newTab);
        if (newTab === DownloadMethodsEnum.QR) {
            trackQRCodeTabClicked();
        } else {
            trackTextMeTabClicked();
        }
    };
    var trackQRCodeTabClicked = function() {
        if (props.appModalType === AppModalType.APPSTORE) {
            trackRetailerMobileFooterDesktopappModaliosScanQrCodeTabClick();
        } else {
            trackRetailerMobileFooterDesktopappModalandroidScanQrCodeTabClick();
        }
    };
    var trackTextMeTabClicked = function() {
        if (props.appModalType === AppModalType.APPSTORE) {
            trackRetailerMobileFooterDesktopappModaliosTextMeTabClick();
        } else {
            trackRetailerMobileFooterDesktopappModalandroidTextMeTabClick();
        }
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        onClose: props.onClose,
        width: "400px",
        height: "auto",
        padding: getSpacing(96, "3x", "3x"),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                style: {
                    alignSelf: "flex-start"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "YUtjdv",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Get the Faire app"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Tabs, {
                tabs: tabs,
                activeTab: activeDownloadMethodTab,
                onTabChange: function(newTab) {
                    return trackAndSetNewTab(newTab);
                }
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            activeDownloadMethodTab === DownloadMethodsEnum.QR ? /*#__PURE__*/ _jsx(QRAppSection, {
                appModalType: props.appModalType
            }) : /*#__PURE__*/ _jsx(TextAppSection, {
                appModalType: props.appModalType,
                onClose: props.onClose,
                loggedOut: true
            })
        ]
    });
};
